export class UseDiscountType {
  static get WarrantyPeriod () {
    return 1
  }
  static get Month () {
    return 2
  }

  static UseDiscountTypeName (UseDiscountType) {
    let tmpType = parseInt(UseDiscountType)
    let type = isNaN(tmpType) ? -1 : tmpType
    let name = ''
    switch (type) {
      case 1:
        name = '期數'
        break
      case 2:
        name = '月份'
        break
    }
    return name
  }
}
